import { BaseTextMergeEditor } from "../BaseTextMergeEditor";
import React from "react";
import { Box } from "@mui/material";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import { LineBreakElement } from "../../../rule-engine-core/TextMerge/Elements/Text/LineBreakElement";
import { BaseTextMergeElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";

export class TextMergeLineBreakEditor extends BaseTextMergeEditor<LineBreakElement> {
    renderDisplay(_config: BaseTextMergeElement, _editContext: TextMergeEditContext): React.ReactNode {
        return <br></br>;
    }

    renderEditor(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <Box
                display={"flex"}
                flexDirection={"row"}
                padding={"3px"}
                margin={"3px"}
                bgcolor={"white"}
                border={editContext.selectedElement?.id === config.id ? "2px solid red" : "1px solid blue"}
                onClick={() => {
                    editContext.setSelectedElement(config);
                }}
                justifyContent={"center"}
            >
                [New Line]
            </Box>
        );
    }

    getIcon(): JSX.Element {
        return <VerticalAlignBottomIcon />;
    }
}
